import { Component, Input,OnChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TourGuideService } from '@app/services/tour-guide.service';
import dummyData from '@app/assets/api-dummy-data.json'

/**
 * This interface represents what kind of data 
 * WorkflowDetailsComponent expects in input
 */
interface WorkflowDetailsData {
  wfhRepoUrl: string,
  wfhBranch: string,
  wfhName: string,
  wfhFileNm: string
}

/**
 * This component is to show details of workflow
 * from which configuration is derived
 */
@Component({
  selector: 'app-workflow-details',
  templateUrl: './workflow-details.component.html',
  styleUrls: ['./workflow-details.component.scss']
})
export class WorkflowDetailsComponent implements OnChanges {

  /****************** Variable declaration ******************/
  formFields: { label: string, controlName: string }[] = [
    { label: 'Repository url', controlName: 'wfhRepoUrl' },
    { label: 'Branch', controlName: 'wfhBranch' },
    { label: 'Workflow file name', controlName: 'wfhFileNm' },
    { label: 'Workflow name', controlName: 'wfName' }
  ]
  workflowDetailsFrom: FormGroup;
  
  /****************** Input and Output decorators ******************/
  @Input() data: WorkflowDetailsData;

  /**
   * Constructor
   * @param tourService 
  */
 constructor(private tourService: TourGuideService) { }

  /**
   * initialization method
   */
  ngOnChanges(){
    this.buildForm();
    this.workflowDetailsFrom.disable();

    if(this.tourService.isStartTour) {
      this.workflowDetailsFrom.patchValue(dummyData.configBuilder.workflow.wfDetailsData[0]);
    }
  }

  /**
   * initialization of the form
   */
  buildForm() {
    this.workflowDetailsFrom = new FormGroup({
      wfhRepoUrl: new FormControl(this.data.wfhRepoUrl),
      wfhBranch: new FormControl(this.data.wfhBranch),
      wfhFileNm: new FormControl(this.data.wfhFileNm),
      wfName: new FormControl(this.data.wfhName)
    });
  }
}
